import { render } from "./WorkspaceList.vue?vue&type=template&id=398a61c4&scoped=true"
import script from "./WorkspaceList.vue?vue&type=script&lang=js"
export * from "./WorkspaceList.vue?vue&type=script&lang=js"

import "./WorkspaceList.vue?vue&type=style&index=0&id=398a61c4&lang=scss&scoped=true"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398a61c4"]])

export default __exports__